import type { CameraMode } from '../../store/gameStore'
import { useGameStore } from '../../store/gameStore'

const TABS: { id: CameraMode; label: string }[] = [
  { id: 'play', label: '플레이' },
  { id: 'overview', label: '전체' },
]

export function BottomTabBar() {
  const cameraMode = useGameStore((s) => s.cameraMode)
  const setCameraMode = useGameStore((s) => s.setCameraMode)
  const setSettingsOpen = useGameStore((s) => s.setSettingsOpen)
  const setMissionsMenuOpen = useGameStore((s) => s.setMissionsMenuOpen)

  return (
    <nav className="overlay-panel flex gap-2 p-2">
      {TABS.map((tab) => {
        const active = cameraMode === tab.id
        return (
          <button
            key={tab.id}
            type="button"
            className={`flex-1 touch-manipulation rounded-xl px-3 py-2.5 text-sm font-semibold transition ${
              active
                ? 'bg-gold text-black'
                : 'bg-white/5 text-white/80 hover:bg-white/10'
            }`}
            onClick={() => setCameraMode(tab.id)}
          >
            {tab.label}
          </button>
        )
      })}
      <button
        type="button"
        className="touch-manipulation rounded-xl bg-white/5 px-3 py-2.5 text-sm font-semibold text-white/80 hover:bg-white/10"
        onClick={() => setMissionsMenuOpen(true)}
        aria-label="미션 및 기록"
      >
        미션
      </button>
      <button
        type="button"
        className="touch-manipulation rounded-xl bg-white/5 px-3 py-2.5 text-sm font-semibold text-white/80 hover:bg-white/10"
        onClick={() => setSettingsOpen(true)}
        aria-label="설정"
      >
        설정
      </button>
    </nav>
  )
}
